var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78571 4.57139C3.17951 4.57139 2.59812 4.81221 2.16947 5.24086C1.74082 5.66952 1.5 6.2509 1.5 6.85711V28.5714C1.5 29.1776 1.74082 29.759 2.16947 30.1876C2.59812 30.6163 3.17951 30.8571 3.78571 30.8571H28.9286C29.5348 30.8571 30.1162 30.6163 30.5448 30.1876C30.9735 29.759 31.2143 29.1776 31.2143 28.5714V6.85711C31.2143 6.2509 30.9735 5.66952 30.5448 5.24086C30.1162 4.81221 29.5348 4.57139 28.9286 4.57139H24.3571M8.35714 1.14282V7.99996M24.3571 1.14282V7.99996M8.35714 4.57139H19.7857",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5012 10.4275C14.1981 10.4275 13.9074 10.5479 13.6931 10.7622C13.4787 10.9766 13.3583 11.2672 13.3583 11.5703V14.7841H10.1401C9.83695 14.7841 9.54626 14.9045 9.33193 15.1188C9.1176 15.3331 8.99719 15.6238 8.99719 15.9269V19.6412C8.99719 19.9443 9.1176 20.235 9.33193 20.4493C9.54626 20.6637 9.83695 20.7841 10.1401 20.7841H13.356V23.9978C13.356 24.3009 13.4765 24.5916 13.6908 24.8059C13.9051 25.0202 14.1958 25.1406 14.4989 25.1406H18.2132C18.3633 25.1406 18.5119 25.1111 18.6505 25.0536C18.7892 24.9962 18.9152 24.912 19.0213 24.8059C19.1274 24.6998 19.2116 24.5738 19.2691 24.4351C19.3265 24.2965 19.3561 24.1479 19.3561 23.9978V20.7841H22.5698C22.8729 20.7841 23.1636 20.6637 23.3779 20.4493C23.5922 20.235 23.7126 19.9443 23.7126 19.6412V15.9269C23.7126 15.6238 23.5922 15.3331 23.3779 15.1188C23.1636 14.9045 22.8729 14.7841 22.5698 14.7841H19.3583V11.5703C19.3583 11.2672 19.2379 10.9766 19.0236 10.7622C18.8093 10.5479 18.5186 10.4275 18.2155 10.4275H14.5012Z",
    stroke: "#696969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.012786c1372d918f6d96adf78b3755f8.svg";
export { ForwardRef as ReactComponent };